

	<template>
	<div class="container-fluid  headerBg ">

		<div
			class="white text-center uppercase Bold"
			:class="{'w-50 margin-header-title' : vw > 1024, 'w-100' : vw <= 1024}"
		>
			<div class="headerBg__title text-shadow ">

				<h1 class="headerBg__title__mega">Vinci</h1>
				<h1 class="headerBg__title__big">Ogni giorno</h1>
				<h1 class="headerBg__title__regular">Un'esperienza unica a casa tua: <br> noi portiamo lo chef.. <br> tu invita 5 amici!</h1>
				<hr class="back-3 headerBg__title__divider my-2 my-lg-5 w-50">
				<h1 class="headerBg__title__small"> Acquista almeno una birra moretti <br> filtrata a freddo 55cl e prova a vincere <br> ogni giorno una cena con chef a casa tua</h1>

			</div>
			<div class="mt-2 mt-lg-5">

				<button-custom
					v-if="timeStore < moment(finish)"
					:to=" !isAuthenticated ? '/' : '/play'"
					:scrollTo="'#section01'"
				> </button-custom>

				<div v-else>Il concorso è terminato</div>

				<!-- <router-link
					to="/"
					v-scroll-to="{ el: '#section01', offset: this.vw > 768 ? -this.navHeight : -this.navHeightSmall}"
					class="btn  btn-primary btn-primary__multi-line-text Bold uppercase"
				>
					<span>Partecipa subito</span>

				</router-link> -->

			</div>
		</div>

	</div>

</template>


	<script>
	import { mapGetters } from 'vuex';

	import { innerWidthMixin } from '../../mixins/innerWidthMixin';
	import { sharedEnvMixin } from '../../mixins/sharedEnvMixin';

	const moment = require('moment');

	export default {
		name: 'header_',
		mixins: [innerWidthMixin, sharedEnvMixin],
		data() {
			return {
				moment: moment,
			};
		},

		methods: {
			playNow: function (val) {
				var _vue = this;
				if (this.vw > 767) {
					/**Pc */
					if (val == 2) {
						setTimeout(function () {
							_vue.$scrollTo('#how-partecipate', 700, { offset: 30 });
						}, 100);
					}
				} else if (this.vw < 330) {
					/*Iphone 5*/
					if (val == 2) {
						setTimeout(function () {
							_vue.$scrollTo('#how-partecipate', 700, { offset: -50 });
						}, 100);
					}
				} else {
					/**Mobile */
					if (val == 2) {
						setTimeout(function () {
							_vue.$scrollTo('#how-partecipate', 700, { offset: -50 });
						}, 100);
					}
				}
			},

			scrollToTop: function () {
				var _vue = this;
				setTimeout(function () {
					_vue.$scrollTo('.main', 700, { offset: -125 });
				}, 100);
			},
		},
		mounted() {},
		computed: {
			...mapGetters(['isAuthenticated', 'authStatus', 'getPromotions']),
			timeStore() {
				return this.$timestore.now;
			},
		},
	};
</script>

